const SubscriberNeeds = ({ children, selectedTab }) => {
  if (selectedTab === 0) {
    return null;
  }
  return children;
};

export default SubscriberNeeds;
